<template>
  <nav class="article-navigation">
    <!-- 装饰性标题 -->
    <div class="nav-header">
      <div class="nav-header-line"></div>
      <div class="nav-header-content">
        <svg
          class="nav-header-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
          />
        </svg>
        <span class="nav-header-text">看看大新闻</span>
      </div>
      <div class="nav-header-line"></div>
    </div>

    <!-- 导航按钮 -->
    <div class="nav-buttons">
      <!-- 上一篇 -->
      <router-link
        v-if="prevArticle"
        :to="prevArticle.link"
        class="nav-button nav-prev"
      >
        <div class="nav-button-bg"></div>
        <div class="nav-button-content">
          <div class="nav-icon-wrapper">
            <svg
              class="nav-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </div>
          <div class="nav-text">
            <span class="nav-label">上一篇</span>
            <h4 class="nav-title">{{ prevArticle.title }}</h4>
          </div>
        </div>
        <div class="nav-button-shine"></div>
      </router-link>
      <div v-else class="nav-button nav-disabled">
        <div class="nav-button-content">
          <div class="nav-icon-wrapper">
            <svg
              class="nav-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </div>
          <div class="nav-text">
            <span class="nav-label">上一篇</span>
            <h4 class="nav-title">没有更多了</h4>
          </div>
        </div>
      </div>

      <!-- 下一篇 -->
      <router-link
        v-if="nextArticle"
        :to="nextArticle.link"
        class="nav-button nav-next"
      >
        <div class="nav-button-bg"></div>
        <div class="nav-button-content">
          <div class="nav-text">
            <span class="nav-label">下一篇</span>
            <h4 class="nav-title">{{ nextArticle.title }}</h4>
          </div>
          <div class="nav-icon-wrapper">
            <svg
              class="nav-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
        <div class="nav-button-shine"></div>
      </router-link>
      <div v-else class="nav-button nav-disabled">
        <div class="nav-button-content">
          <div class="nav-text">
            <span class="nav-label">下一篇</span>
            <h4 class="nav-title">没有更多了</h4>
          </div>
          <div class="nav-icon-wrapper">
            <svg
              class="nav-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ArticleNavigation",
  props: {
    prevArticle: {
      type: Object,
      default: null,
    },
    nextArticle: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.article-navigation {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

/* 装饰性标题 */
.nav-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.nav-header-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, transparent, #e5e7eb, transparent);
}

.nav-header-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #eff6ff, #f5f3ff);
  border-radius: 20px;
  border: 1px solid #e0e7ff;
}

.nav-header-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #3b82f6;
}

.nav-header-text {
  font-size: 0.875rem;
  font-weight: 600;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 导航按钮容器 */
.nav-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

/* 导航按钮 */
.nav-button {
  position: relative;
  display: flex;
  padding: 1.25rem;
  background: linear-gradient(135deg, #fafafa, #ffffff);
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  text-decoration: none;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 100px;
}

.nav-button:not(.nav-disabled) {
  cursor: pointer;
}

.nav-button:not(.nav-disabled):hover {
  border-color: transparent;
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -4px rgba(59, 130, 246, 0.2),
    0 8px 16px -4px rgba(139, 92, 246, 0.15);
}

/* 背景渐变 */
.nav-button-bg {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.nav-prev .nav-button-bg {
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.08),
    rgba(139, 92, 246, 0.05)
  );
}

.nav-next .nav-button-bg {
  background: linear-gradient(
    135deg,
    rgba(139, 92, 246, 0.05),
    rgba(236, 72, 153, 0.08)
  );
}

.nav-button:not(.nav-disabled):hover .nav-button-bg {
  opacity: 1;
}

/* 光泽效果 */
.nav-button-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.6),
    transparent
  );
  transition: left 0.6s ease;
}

.nav-button:not(.nav-disabled):hover .nav-button-shine {
  left: 100%;
}

/* 按钮内容 */
.nav-button-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  z-index: 1;
}

.nav-prev .nav-button-content {
  flex-direction: row;
}

.nav-next .nav-button-content {
  flex-direction: row-reverse;
}

/* 图标包装器 */
.nav-icon-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ffffff, #f8fafc);
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-prev:not(.nav-disabled):hover .nav-icon-wrapper {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border-color: #3b82f6;
  transform: translateX(-4px);
}

.nav-next:not(.nav-disabled):hover .nav-icon-wrapper {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  border-color: #8b5cf6;
  transform: translateX(4px);
}

.nav-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #6b7280;
  transition: color 0.4s ease;
}

.nav-button:not(.nav-disabled):hover .nav-icon {
  color: #ffffff;
}

/* 文字区域 */
.nav-text {
  flex: 1;
  min-width: 0;
}

.nav-prev .nav-text {
  text-align: left;
}

.nav-next .nav-text {
  text-align: right;
}

.nav-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9ca3af;
  margin-bottom: 0.375rem;
  transition: color 0.3s ease;
}

.nav-button:not(.nav-disabled):hover .nav-label {
  color: #6b7280;
}

.nav-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: all 0.3s ease;
}

.nav-prev:not(.nav-disabled):hover .nav-title {
  color: #3b82f6;
}

.nav-next:not(.nav-disabled):hover .nav-title {
  color: #8b5cf6;
}

/* 禁用状态 */
.nav-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-disabled .nav-icon-wrapper {
  background: #f3f4f6;
  border-color: #e5e7eb;
}

.nav-disabled .nav-icon {
  color: #d1d5db;
}

.nav-disabled .nav-title {
  color: #9ca3af;
}

/* 响应式 */
@media (max-width: 768px) {
  .nav-buttons {
    grid-template-columns: 1fr;
  }

  .nav-button {
    padding: 1rem;
    min-height: 80px;
  }

  .nav-icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .nav-icon {
    width: 1.25rem;
    height: 1.25rem;
  }

  .nav-title {
    font-size: 0.875rem;
  }

  .nav-header-content {
    padding: 0.375rem 0.75rem;
  }

  .nav-header-text {
    font-size: 0.8125rem;
  }
}
</style>
